import { screenShot } from "../svg";
class VideoScreenShot {
  constructor() {
    this.title = "插入截图";
    this.iconSvg = screenShot;
    this.tag = "button";
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive(editor) {
    // JS 语法
    return false;
  }

  getValue(editor) {
    return "";
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false

  isDisabled(editor) {
    return false;
  }

  // 点击菜单时触发的函数
  exec(editor, value) {
    // console.log("点击了截图");
    // return;
    // Modal menu ，这个函数不用写，空着即可
    editor.emit("xhEmitInsertVideoScreenShot");
  }

  // 弹出框 modal 的定位：1. 返回某一个 SlateNode； 2. 返回 null （根据当前选区自动定位）
  getModalPositionNode(editor) {
    return null; // modal 依据选区定位
  }

  // 定义 modal 内部的 DOM Element
  getModalContentElem(editor) {
    // const $content = $("<div></div>");
    // const $button = $("<button>do something</button>");
    // $content.append($button);
    // $button.on("click", () => {
    //   editor.insertText(" hello ");
    // });
    // return $content[0]; // 返回 DOM Element 类型
    // PS：也可以把 $content 缓存下来，这样不用每次重复创建、重复绑定事件，优化性能
  }
}
export const videoScreenShot = {
  key: "xhVideoScreenShotKey", // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new VideoScreenShot(); // 把 `YourMenuClass` 替换为你菜单的 class
  },
};
